import { useCallback, useState } from "react";

import { buildChartsRequestMessage } from "src/flow/analytics/m1/suggestedQuestions/buildChartsRequestMessage";

export const useFlowChartRequest = (
  flowId: string,
): {
  pendingMessage: string | null;
  requestCharts: (questions: string[]) => void;
  clearRequest: () => void;
} => {
  const [request, setRequest] = useState<{
    flowId: string;
    message: string;
  } | null>(null);

  if (request !== null && request.flowId !== flowId) setRequest(null);

  return {
    pendingMessage: request?.flowId === flowId ? request.message : null,
    requestCharts: useCallback(
      (questions: string[]) =>
        setRequest({ flowId, message: buildChartsRequestMessage(questions) }),
      [flowId],
    ),
    clearRequest: useCallback(() => setRequest(null), []),
  };
};
